import { Contract } from "ethers";
import { ethers } from "ethers";
import toast from "react-hot-toast";
import {
  scoreboard_address,
  scoreboard_abi,
} from "./SFM-ScoreBoardContract_Constansts";
import { TREASURY_PRIVATE_KEY } from "./SECRETS";

export const updateScore = async (score) => {
  const provider = new ethers.providers.Web3Provider(window.ethereum);
  const chainID = (await provider.getNetwork()).chainId;
  if (chainID === 84532) {
    const player_signer = provider.getSigner();
    const tresurey_signer = new ethers.Wallet(TREASURY_PRIVATE_KEY, provider);
    const player_address = await player_signer.getAddress();
    // Connect to the Contract
    const contract = new Contract(
      scoreboard_address,
      scoreboard_abi,
      tresurey_signer
    );
    try {
      const response = await contract.updateScore(player_address, score,
        {
          gasLimit: 5000000,
          gasPrice: ethers.utils.parseUnits("10", "gwei"),
        }
        );
      const receipt = await response.wait();
      console.log("receipt: ", JSON.stringify(receipt));
      // toast.promise(tx.wait(), {
      //   loading: "Submiting your score",
      //   success: "Score submitted!",
      //   error: "Score submission failed",
      // });
      // return tx.wait();
    } catch (e) {
      toast.error("Score submission failed");
      console.log(e);
    }
  } else {
    toast.error("Please connect to Base Sepolia Testnet");
  }
};

export const getTopScores = async () => {
  const provider = new ethers.providers.Web3Provider(window.ethereum);
  const chainID = (await provider.getNetwork()).chainId;
  if (chainID === 84532) {
    const signer = provider.getSigner();
    // Connect to the Contract
    const contract = new Contract(scoreboard_address, scoreboard_abi, signer);
    try {
      const tx = await contract.getCurrentTopPlayersScores();
      let scores = [];
      for (let i = 0; i < tx[0].length; i++) {
        if (!scores.includes(tx[0][i]))
          scores.push({
            address: `${tx[0][i].substr(0, 4)}....${tx[0][i].substr(
              tx[0][i].length - 4
            )}`,
            score: tx[1][i].toNumber(),
          });
      }
      return scores;
    } catch (e) {
      toast.error("Top scores fetch failed");
    }
  } else {
    toast.error("Please connect to Base Sepolia Testnet");
  }
};

export const getMyAddress = async () => {
  const provider = new ethers.providers.Web3Provider(window.ethereum);
  const chainID = (await provider.getNetwork()).chainId;
  if (chainID === 84532) {
    const signer = provider.getSigner();
    const address = await signer.getAddress();
    return address;
  } else {
    toast.error("Please connect to Base Sepolia Testnet");
  }
};
